<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="personCategory.name"
      label="Nome"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      personCategory: {},
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.personCategory = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.personCategory)
    },
  },
}
</script>
